import { render, staticRenderFns } from "./leaveman.vue?vue&type=template&id=5ea78e8e&scoped=true"
import script from "./leaveman.vue?vue&type=script&lang=js"
export * from "./leaveman.vue?vue&type=script&lang=js"
import style0 from "./leaveman.vue?vue&type=style&index=0&id=5ea78e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea78e8e",
  null
  
)

export default component.exports